import React, { useEffect, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { delete_icon, edit_icon, Search_icon } from "../../../assets/img";
import Topbar from "../../../components/Topbar/Topbar";
import { Table } from "../../../components/Table/Table";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { checkPermission } from "../../redux/api/PermissionManager";

const MinimumAge = () => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState({ year: false, month: false });
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [totalCount, setTotalCount] = useState();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  // ✅ fetch list
  const fetch = async (page = 1) => {
    const url = search
      ? `${URLS.MASTERURL}?type=${14}&search=${search}`
      : `${URLS.MASTERURL}?type=${14}&page=${page}`;

    try {
      const res = await get(url);
      let modified = (res?.data ?? [])?.map((item) => ({
        ...item,
        name: item?.name?.replace("Age - ", ""),
      }));
      setList(modified);
      setTotalCount(res?.count);
      // Assuming 10 items per page
      const pageSize = 10;
      const lastPage = Math.ceil((res?.count || 0) / pageSize);
      setPagination({ current_page: page, last_page: lastPage });
    } catch (err) {
      console.log("err", err);
    }
  };

  // ✅ toggle status
  const handleStatus = async ({ id, status }) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("status", !status);

    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetch(page);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  // ✅ delete
  const handleDelete = async () => {
    setPopup(false);
    setLoading(true);
    try {
      const res = await post(`${URLS.MASTERURL}${editId}/delete/`);
      fetch(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ submit
  const handleSubmit = async () => {
    if (!year) {
      setErrors((prev) => ({ ...prev, year: true }));
      return;
    }

    setLoading(true);
    setAddPopup(false);

    const formdata = new FormData();
    formdata.append("type", 14);
    formdata.append("name", `Age - ${year}Y${month && `+${month}M`}`);

    try {
      if (type === "add") {
        formdata.append("status", true);
        const res = await post(`${URLS.MASTERURL}add/`, formdata);
        if (res.status === "success") {
          toast.success(res.message || "Added successfully");
        }
      } else if (type === "edit") {
        const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
        if (res.status === "success") {
          toast.success(res.message || "Edited successfully");
        }
      }
      fetch(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch(page);
  }, [search, page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Age",
        accessor: "name",
        Cell: ({ value }) => <p>{value}</p>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <button
            onClick={() => {
              if (checkPermission("CAN-STATUS-AGE")) handleStatus(row.original);
            }}
            className={`${value ? "active-btn" : "deactive-btn"} border-0`}
          >
            {value ? "Active" : "De-active"}
          </button>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div className="d-flex ac-js gap-3">
            {checkPermission("CAN-EDIT-AGE") && (
              <button
                onClick={() => {
                  setAddPopup(true);
                  setType("edit");
                  setEditId(row.original.id);
                  const [y, m] = row.original.name?.split("+");
                  console.log("clicked", y, m);
                  setYear(y.replace("Y", "") || "");
                  if (m) setMonth(m.replace("M", "") || "");
                }}
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className=" edit-btn " />
              </button>
            )}
            {checkPermission("CAN-DELETE-AGE") && (
              <button
                onClick={() => {
                  setPopup(true);
                  setEditId(row.original.id);
                }}
                className="cust-btn "
              >
                <img src={delete_icon} alt="" className=" edit-btn " />
              </button>
            )}
          </div>
        ),
      },
    ],
    [page]
  );

  return (
    <div>
      {loading && <Loader />}
      <Topbar header={"Master"} subHead={"Age"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount || list?.length || 0}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" alt="search" />
          </div>
          {checkPermission("CAN-ADD-AGE") && (
            <button
              onClick={() => {
                setAddPopup(true);
                setType("add");
                setYear("");
                setMonth("");
              }}
              className="f2 white add-btn "
            >
              + Add New
            </button>
          )}
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />

      {/* Add / Edit Popup */}
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4">Age</p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setYear("");
                  setMonth("");
                  setErrors({ year: false, month: false });
                }}
                className="pointer"
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-js gap-3">
              <div className="w-40">
                <input
                  className="input-box"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  type="number"
                  placeholder="Year"
                />
                {errors.year && <p className="err text-start">Enter Year</p>}
              </div>
              <div className="w-40">
                <input
                  className="input-box"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  type="number"
                  placeholder="Month"
                />
                {errors.month && <p className="err text-start">Enter Month</p>}
              </div>
            </div>

            <div className="d-flex ac-je px-2 mt-4">
              <button onClick={handleSubmit} className="submit-btn f2 w-40 p-2">
                {type === "add" ? "Add" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 mt-4">Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => setPopup(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MinimumAge;
